export const apiEn = {};

export const apiFr = {};
